import { partnerAdminFetch } from '~/api/partnerAdminFetch';
import { ClientType, clientSearchParams } from '../../types/resources/ClientType';

type GetResponseType = {
  data: {
    clients: ClientType[];
  };
  headers: Record<string, string>;
};

export async function getClients(
  signOut?: () => void,
  searchParams?: clientSearchParams
): Promise<GetResponseType> {
  const queryString = new URLSearchParams(searchParams).toString();
  const response = await partnerAdminFetch(
    `/partner_admins/clients${queryString ? `?${queryString}` : ''}`,
    {
      method: 'GET',
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return {
    data,
    headers: Object.fromEntries(response.headers.entries()),
  };
}

export async function getClientsCSV(signOut?: () => void): Promise<{ data: Blob }> {
  const response = await partnerAdminFetch(
    '/partner_admins/clients.csv',
    {
      method: 'GET',
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const data = await response.blob();

  return { data };
}
